<template>
  <widget-wrapper
    :id="configItem.chartId"
    :title="chartAttr.title"
    :subTitle="chartAttr.subtitle"
    :addtxt="chartAttr.addtxt"
    :info="chartAttr.info"
    :empty="empty"
    :loading="loadingbar"
    @ctrl="ctrlClick"
    class="default6"
  >
    <div class="wrapper-chart">
      <div class="chart-area">
        <v-chart
          ref="chart"
          :autoresize="true"
          :option="buildOption()"
          style="width: 100%; top: -34px; position: relative"
        />
      </div>

      <div class="note-area">
        <div class="chart-note">
          <div class="title flex space-bw">
            <span>{{ $t('title.active') }}</span>
            <span>{{ $t('title.inactive') }}</span>
          </div>
          <div class="total flex space-bw">
            <c-label style="width: initial; text-align: left">
              {{ getTotalDataTypeEvent('active') }}
            </c-label>
            <span></span>
            <c-label style="width: initial; text-align: end">
              {{ getTotalDataTypeEvent('inactive') }}
            </c-label>
          </div>

          <div
            class="detail flex space-bw"
            v-for="(eventType, idx) in Object.keys(eventTypeData)"
            :key="idx"
          >
            <div
              class="text"
              style="justify-content: flex-start"
              @click="handleClickNote(eventType)"
            >
              <c-label style="width: initial">
                {{ getSum(eventTypeData[eventType].active) }}
              </c-label>
            </div>
            <div class="title-detail">
              <div
                class="icon-detail"
                :style="`background-color: ${getColor(eventType)}; opacity: ${
                  showHiddenDataChart[eventType].active ? 1 : 0.5
                }`"
                @click="handleClickNote(eventType)"
              ></div>
              <span class="type">{{ $util.capitalize(eventType) }}</span>
              <div
                class="icon-detail"
                :style="`background-image: url(${getColor(eventType, false)}); opacity: ${
                  showHiddenDataChart[eventType].inactive ? 1 : 0.5
                }`"
                @click="handleClickNote(eventType, false)"
              ></div>
            </div>
            <div
              class="text"
              style="justify-content: flex-end"
              @click="handleClickNote(eventType, false)"
            >
              <c-label style="width: initial">
                {{ getSum(eventTypeData[eventType].inactive) }}
              </c-label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </widget-wrapper>
</template>
<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from './widgetMixin';
import moment from 'moment';
import { getWidgetData } from '../serviceApi';

const DATA_KEY = { active: 'active', inactive: 'inactive' };
const LOG_TYPE = ['FATAL', 'WARNING', 'INFORM'];

export default {
  name: 'EventHistroyWidget',
  components: { widgetWrapper, 'v-chart': ECharts },
  mixins: [widgetMixin],
  props: {
    searchDate: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    empty() {
      return this.$util.isEmpty(this.seriesChart) || !this.isWidgetAuth;
    }
  },
  data() {
    return {
      rawData: [],
      fromDate: '',
      toDate: '',
      eventTypeData: {},
      xAxisLabel: [],
      seriesChart: [],
      showHiddenDataChart: {}
    };
  },
  watch: {
    showHiddenDataChart: {
      deep: true,
      immediate: false,
      handler() {
        this.buildDataChart();
      }
    }
  },
  created() {
    this.buildDefaultData();
  },
  mounted() {},
  methods: {
    buildDefaultData() {
      for (const event of LOG_TYPE) {
        this.eventTypeData[event] = {
          [DATA_KEY.active]: [],
          [DATA_KEY.inactive]: []
        };
        this.showHiddenDataChart[event] = {
          [DATA_KEY.active]: true,
          [DATA_KEY.inactive]: true
        };
      }
    },

    // API call getData
    getData() {
      const params = {
        queryStartDt: this.searchDate.queryStartDt,
        queryEndDt: this.searchDate.queryEndDt,
        timeZone: 'UTC'
      };
      getWidgetData('get', this.configItem.chartAttr.widget.api, params, this.header).then(
        (data) => {
          if (data instanceof Error) {
            return;
          }
          this.buildDefaultData();

          this.rawData = data.contents;
          const contents = data.contents;

          for (const data of contents) {
            for (const info of data.eventCountDatas) {
              const eventLevel = info.eventLevel;
              this.eventTypeData[eventLevel].active.push(Number(info.active));
              this.eventTypeData[eventLevel].inactive.push(Number(info.inactive));
            }
          }
          this.buildDataChart();
          if (!data.contents.length) return;
        }
      );
    },
    xLabelFormatter(value) {
      let type = this.searchDate.chartTimeUnit;
      return this.$util.getDateFormat(value, type);
    },
    buildDataChart() {
      this.xAxisLabel = this.rawData.map((item) => {
        return {
          value: this.xLabelFormatter(item.eventCountDatas[0].ts * 1000)
        };
      });

      this.seriesChart = [];

      for (const eventLevel of LOG_TYPE) {
        const info = {
          name: eventLevel,
          type: 'bar',
          barGap: '0%',
          stack: eventLevel,
          data: [],
          cursor: 'default'
        };

        for (const dataType of Object.values(DATA_KEY)) {
          const isActive = dataType === DATA_KEY.active;

          const showChartData = this.showHiddenDataChart[eventLevel]
            ? this.showHiddenDataChart[eventLevel][dataType]
            : false;

          this.seriesChart.push({
            ...info,
            data: showChartData ? this.eventTypeData[eventLevel][dataType] : [0, 0, 0, 0, 0, 0, 0],
            itemStyle: {
              emphasis: { cursor: 'default' },
              normal: {
                borderRadius: isActive ? [0, 0, 0, 0] : [2, 2, 0, 0],
                color: isActive
                  ? this.getColor(eventLevel)
                  : {
                      type: 'image',
                      repeat: 'repeat',
                      image: this.getColor(eventLevel, false)
                    }
              }
            }
          });
        }
      }
    },

    capitalize(str) {
      return (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).substr(0, 3);
    },

    formatNumberWithComma(value) {
      return value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    },

    getSum(array = []) {
      return this.formatNumberWithComma(array.reduce((a, b) => a + b, 0));
    },

    getTotalDataTypeEvent(dataKey) {
      const array = [];
      Object.keys(this.eventTypeData).forEach((key) => {
        const item = this.eventTypeData[key];
        if (dataKey in item) {
          array.push(...item[dataKey]);
        }
      });

      return this.getSum(array);
    },

    getColor(level, color = true) {
      switch (level) {
        case 'INFORM':
          if (color) return '#8a8f99';
          return require('@/assets/img/scmp/inform.png');
        case 'WARNING':
          if (color) return '#FFD035';
          return require('@/assets/img/scmp/warning.png');
        case 'FATAL':
          if (color) return '#FC8289';
          return require('@/assets/img/scmp/fatal.png');

        default:
          break;
      }
    },

    handleClickNote(level, active = true) {
      const type = active ? DATA_KEY.active : DATA_KEY.inactive;
      this.showHiddenDataChart[level][type] = !this.showHiddenDataChart[level][type];
    },

    buildOption() {
      const self = this;
      const option = {
        grid: {
          left: '38px'
        },
        tooltip: {
          trigger: 'item',
          position: 'top',
          axisPointer: {
            type: 'none'
          },
          backgroundColor: '#1f2533',
          borderWidth: 1,
          borderColor: '#787c84',
          borderRadius: 0,
          padding: [4, 8, 4, 8],
          textStyle: {
            color: '#fff',
            fontSize: 12,
            lineHeight: 20
          },
          formatter: function (params) {
            const data = self.eventTypeData[params.seriesName];

            return (
              `${self.$t('title.occurrence')}: ` +
              (data[DATA_KEY.inactive][params.dataIndex] +
                data[DATA_KEY.active][params.dataIndex]) +
              '<br />' +
              `${self.$t('title.active')}: ` +
              data[DATA_KEY.active][params.dataIndex] +
              '<br />' +
              `${self.$t('title.inactive')}: ` +
              data[DATA_KEY.inactive][params.dataIndex]
            );
          }
        },
        xAxis: {
          type: 'category',
          data: self.xAxisLabel,
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: function (label, index) {
              return label;
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '(cnt)',
          axisLabel: {
            formatter: function (label) {
              return self.formatNumberWithComma(label);
            }
          }
        },
        series: self.seriesChart
      };

      return option;
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}

.space-bw {
  justify-content: space-between;
  padding-bottom: 14px;
}

.chart-note {
  margin-top: 28px;

  .title {
    border-bottom: 1px solid #e4e5e7;

    span {
      font-family: $lego__font-family;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 12px;
      color: #2f3237;
    }
  }

  .total {
    margin-top: 8px;

    div {
      font-family: $lego__font-family;
      font-size: 15px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 16px !important;
      color: #2f3237 !important;
      width: 70px !important;
    }
  }

  .detail {
    .text {
      div {
        font-family: $lego__font-family;
        font-size: 14px;
        font-style: normal;
        font-weight: 400 !important;
        line-height: 16px !important;
        color: #2f3237 !important;
      }

      width: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .icon-detail {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      cursor: pointer;
    }

    .type {
      width: 56px;
    }

    .title-detail {
      display: flex;
      align-items: center;
      width: 90px;
      justify-content: space-between;
      text-align: left;

      span {
        font-family: $lego__font-family;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;
      }
    }
  }
}

.widget-chart-bar {
  height: auto;
  margin: 0 auto;
}

.default6 :deep .widget-body {
  padding: 0px 20px;
}

.default6 :deep .echarts {
  min-height: 285px !important;
}

.default6 :deep .chart-tooltip span {
  color: #fff !important;
}

.wrapper-chart {
  height: 100%;
  display: flex;

  .chart-area {
    width: calc(100% - 180px);
  }

  .note-area {
    min-width: 180px;
    max-width: 180px;
  }
}
</style>
